// Параметры отчёта по баллам: даты по Москве (ГГГГ-ММ-ДД), источник, группировка, категории.
export function buildPeriodQuery({ dateFrom, dateTo, source, group, categories = [] }) {
  const params = [
    `date_from=${encodeURIComponent(dateFrom)}`,
    `date_to=${encodeURIComponent(dateTo)}`,
  ]
  if (source) params.push(`source=${encodeURIComponent(source)}`)
  if (group) params.push(`group=${encodeURIComponent(group)}`)
  categories.forEach((category) => params.push(`categories[]=${encodeURIComponent(category)}`))

  return params.join("&")
}

export async function downloadCsv(api, path, filename) {
  const file = await api.get(path, { useV2Api: true, responseType: "blob" })
  const blob = new Blob([file], { type: "text/csv;charset=utf-8" })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()

  window.URL.revokeObjectURL(url)
}
